import { BasePage } from '@/components/ui/base-page'

export function TiendaPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add TiendaPage specific content here */}
    </BasePage>
  )
}